import {BikeCategory} from "./BikeCategory";

export const PRICE_CATEGORY = {
  [
    BikeCategory.CITYBIKE_URBANBIKE]: {
    '<1000': {leasingfaktor: 2.38, uebernahmeprozent: 23},
    '1000-3500': {leasingfaktor: 2.76, uebernahmeprozent: 23},
    '>3500': {leasingfaktor: 2.76, uebernahmeprozent: 23}
  },
  [BikeCategory.TREKKINGBIKE_MTB_ATB]: {
    '<1000': {leasingfaktor: 2.38, uebernahmeprozent: 23},
    '1000-3500': {leasingfaktor: 2.76, uebernahmeprozent: 23},
    '>3500': {leasingfaktor: 2.76, uebernahmeprozent: 23}
  },
  [BikeCategory.RENNRAD_GRAVELBIKE_CROSSBIKE_FITNESSBIKE]: {
    '<1000': {leasingfaktor: 2.38, uebernahmeprozent: 23},
    '1000-3500': {leasingfaktor: 3.00, uebernahmeprozent: 23},
    '>3500': {leasingfaktor: 3.10, uebernahmeprozent: 23}
  },
  [BikeCategory.LASTENRAD]: {
    '<1000': {leasingfaktor: 2.38, uebernahmeprozent: 23},
    '1000-3500': {leasingfaktor: 3.00, uebernahmeprozent: 23},
    '>3500': {leasingfaktor: 3.10, uebernahmeprozent: 23}
  },
  [BikeCategory.E_BIKE_PEDELEC]: {
    '<1000': {leasingfaktor: 2.80, uebernahmeprozent: 18},
    '1000-3500': {leasingfaktor: 3.31, uebernahmeprozent: 18},
    '>3500': {leasingfaktor: 3.31, uebernahmeprozent: 18}
  },
  [BikeCategory.OTHER]: {
    '<1000': {leasingfaktor: 2.80, uebernahmeprozent: 18},
    '1000-3500': {leasingfaktor: 3.31, uebernahmeprozent: 18},
    '>3500': {leasingfaktor: 3.31, uebernahmeprozent: 18}
  },
};
